import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { LanguageProvider } from "@/context/LanguageContext";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import TreatmentPage from "@/pages/TreatmentPage";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <ReactLenis root options={{ lerp: 0.08, smoothWheel: true }}>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/treatment/:key" element={<TreatmentPage />} />
              <Route path="/admin" element={<Admin />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="bottom-right" />
        </ReactLenis>
      </LanguageProvider>
    </div>
  );
}

export default App;
